import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConstantService } from 'src/app/service/constant.service';
import { GamesService } from 'src/app/service/games.service';
import { TranslateService } from '@ngx-translate/core';
import {
  SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import * as $ from 'jquery';
// import { clearInterval } from 'timers';
export enum fiterTypes { All, LiveGame, VirtualGame, PowerGame, WidGetGame };
@Component({
  selector: 'app-lobby',
  templateUrl: './lobby.component.html',
  styleUrls: ['./lobby.component.scss']
})
export class LobbyComponent implements OnInit {
  // IsVerified = false;
  IsCallMade = false;
  ShowGameList = false;
  IsReload = false;
  isLoading = true;
  Token = '';
  Code = '';
  UserName = 'User';
  GameLiability = 0;
  vacuumeGameList: any[] = [];
  DisplayMessage: any = '';
  selectedfiterType = fiterTypes.All;
  fiterType = fiterTypes;
  tmpGameList: any[] = [];
  private balanceInterval: any;
  gameList: any[] = [];
  loader = 'assets/images/logo/supernowa-logo.png';
  gameInterval: any;
  newGameUrl:any;
  classicGameUrl:any;
  // hubConnection = new HubConnectionModel();
  @ViewChild(SwiperComponent) componentRef: SwiperComponent;
  public config: SwiperConfigInterface = {
    slidesPerView: 5,
    preventClicks: true,
    preventClicksPropagation: true,
    // keyboard: true,
    // mousewheel: true,
    // scrollbar: false,
    navigation: true,
    // pagination: false,
    centeredSlides: false,
    loop: false,
    observer: true,
    spaceBetween: 10,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    loopedSlides: 23,
    slidesPerGroup: 1,
    allowTouchMove: true,
    freeMode: true,
    initialSlide: 0,
    breakpoints: {
      2100: {
        slidesPerView: 9
      },
      1800: {
        slidesPerView: 7
      },
      1500: {
        slidesPerView: 6
      },
      1200: {
        slidesPerView: 5
      },
      991: {
        slidesPerView: 5
      },
      768: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 3
      },
      480: {
        slidesPerView: 2
      },
      360: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 2
      },
      319: {
        slidesPerView: 1
      },
      0: {
        slidesPerView: 1
      }
    },
  };
  array10 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  constructor(
    private gamesService: GamesService
    , public constant: ConstantService,
    public translateService: TranslateService,
    private router: Router
    , private toastr: ToastrService
  ) {
    this.constant.lobbyGameDropDown = false;
  }

  ngOnInit(): void {
    this.constant.newsList = [];
    this.constant.gameId = 0;
    sessionStorage.removeItem('GameId');
    const LoginLink = sessionStorage.getItem('LoginLink');
    sessionStorage.setItem('LoginLink', LoginLink);
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    if (Token && Token !== '') {
      this.Token = Token;
      sessionStorage.setItem('AuthToken', this.Token);
      this.constant.gameList = sessionStorage.getItem('GameList') ? JSON.parse(sessionStorage.getItem('GameList')) : [];
      this.gameFilterList(fiterTypes.All);
      clearInterval(this.gameInterval);
      this.gameInterval = setInterval(() => {
        if (this.constant.GameTypePermission !== null) {
          // this.GameFilter();
          this.gameFilterList(fiterTypes.All);
          clearInterval(this.gameInterval);
        }
      }, 100);
    } else {
      this.constant.IsVerified = false;
      this.DisplayMessage = this.translateService.instant('Invalid Token. Please Login Again');
    }
    if (this.constant.tmpGameList.length > 0) {
      this.constant.tmpGameList.forEach(element => {
        element.isLoaded = false;
      });
    }
    // setTimeout(() => {
    this.CheckLobby();
    // }, 2000);
  }

  OrderBy() {
    return 0;
  }

  CheckLobby() {
    // constant.tmpGameList
    // console.log("lb");
    if ((this.constant.isLobbyShowLive == false) || (this.constant.isLobbyShowVirtual == false)) {
      if (this.constant.WebsiteURLLive != '' && this.constant.WebsiteURLLive != null) {
        window.top.location.href = this.constant.WebsiteURLLive;
        // this.router.navigateByUrl(this.constant.WebsiteURLLive);
      } else if (this.constant.WebsiteURLVirtual != '' && this.constant.WebsiteURLVirtual != null) {
        window.top.location.href = this.constant.WebsiteURLVirtual;
        // this.router.navigateByUrl(this.constant.WebsiteURLVirtual);
      } else {
        this.constant.IsVerified = false;
        // this.cdr.detectChanges();
        this.DisplayMessage = this.translateService.instant('Invalid Token. Please Login Again');
      }
      // window.top.location.href = this.liveUserDetail.WebsiteURL;
    }
  }
  // getGameList() {
  //   this.gamesService.getGameList({ Token: this.Token }).subscribe(data => {
  //     if (data.Status.code === 0) {
  //       this.gameList = data.GameList;
  //       this.constant.IsVerified = true;
  //       this.constant.userName = data.UserName;
  //       this.constant.balance = data.Balance;
  //       this.constant.liability = data.Liability;
  //       this.constant.chipsSetting = data.ChipSetting ? JSON.parse(data.ChipSetting) : this.constant.chipsSetting;
  //       // this.constant.userDetail = data.UserDetail;
  //       sessionStorage.setItem('UserName', data.UserName);
  //       sessionStorage.setItem('GameList', JSON.stringify(this.gameList));
  //       sessionStorage.setItem('NewsList', JSON.stringify(data.NewsList));
  //       sessionStorage.setItem('ChipSetting', data.ChipSetting);
  //       sessionStorage.setItem('LiveuserDetail', JSON.stringify(data.LiveuserDetail));
  //       sessionStorage.setItem('VirtualuserDetail', JSON.stringify(data.VirtualuserDetail));
  //       // sessionStorage.setItem('UserDetail', JSON.stringify(data.UserDetail));
  //       this.gameFilterList(fiterTypes.All);
  //     }
  //     else {
  //       this.constant.IsVerified = false;
  //       this.DisplayMessage = this.constant.TranslateErrorCode(data.Status);
  //     }
  //   }, err => {
  //     console.log(err);
  //   });
  // }

  gameFilterList(type: fiterTypes) {
    this.selectedfiterType = type;
    this.tmpGameList = [];
    // this.tmpGameList = this.gameList;
    if (this.selectedfiterType === fiterTypes.WidGetGame) {
      this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameCode.trim() === 'TP' || x.GameCode.trim() === 'DT');
    } else {
      if (this.constant.GameTypePermission === 4) {
        this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameCode.trim() === 'TP' || x.GameCode.trim() === 'DT');
      } else if (this.constant.GameTypePermission === 6) {
        if (this.selectedfiterType === fiterTypes.VirtualGame) {
          this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameType === this.fiterType[this.selectedfiterType] || this.selectedfiterType === this.fiterType.All);
        } else {
          this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameType === this.fiterType[2] || x.GameCode.trim() === 'TP' || x.GameCode.trim() === 'DT');
        }
      } else {
        this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameType === this.fiterType[this.selectedfiterType] || this.selectedfiterType === this.fiterType.All);
      }
    }
    this.constant.tmpGameList.forEach(element => {
      element.isLoading = false;
    });
  }

  async NavigatoToGame(item, index) {
    this.constant.isIfreameLodded = true;
    let PrevLang = sessionStorage.getItem('Lng');
    // item.GameUrl = item.GameUrl.replace('Token', 'ln=' + this.constant.translate.currentLang + '&Token');
    // item.GameUrl = item.GameUrl + '&ln=' + this.constant.translate.currentLang;
    if (item.GameType === 'PowerGame') {
      this.vacuumLogin(item.GameCode)
    } else {
      this.checkGameStatus(item, index);
      if (!this.constant.isClassicView) {
        // let isVirtualOrDealer = item.GameUrl.split('/');
        // console.log(isVirtualOrDealer);
        if (this.constant.isClassicView == false) {
          item.GameUrl = this.constant.ReplaceGameUrl(item.GameUrl);
        }
        // if (isVirtualOrDealer[2] === 'virtual.supernowa.net') {
        //   item.GameUrl = item.GameUrl.replace('https://virtual.supernowa.net', 'https://designrnggame.supernowa.net');
        // } else {
        //   // item.GameUrl = item.GameUrl.replace('https://staginglive.supernowa.net', 'https://designlobby.supernowa.net/');
        //   item.GameUrl = item.GameUrl.replace('https://live.supernowa.net', 'https://designlivegame.supernowa.net');
        // }
      }
      sessionStorage.setItem('GameUrl', JSON.stringify(item.GameUrl));
      sessionStorage.setItem('GameId', JSON.stringify(item.GameID));
      sessionStorage.setItem('GameName', JSON.stringify(item.Name));
      sessionStorage.setItem('GameIndex', index);
      sessionStorage.setItem('AuthToken', this.Token);
      this.constant.gameName = item.Name;
      this.router.navigate(['/games']);
    }
  }
  async checkGameStatus(game, index) {
    let gametype = 'Live'
    if (game.Name && (game.Name.includes('Virtual') || game.Name.includes('Rng') || game.Name.includes('RNG'))) {
      gametype = "Virtual";
    }
    let gameDetail = {
      GameCode: game.GameCode.trim(),
      GameType: gametype,
      ClientUsername: this.constant.userName,
    };
    this.gamesService.CheckGameStatus(gameDetail).subscribe((data) => {
      let gameDetail = null;
      let GameIndex = 0;
      if (data.data.Code === '1') {
        gameDetail = this.constant.tmpGameList.find(function (item, i) {
          if (item.GameCode.trim() === data.data.GameCode.trim()) {
            GameIndex = i;
            return i;
          }
        });
        this.toastr.error(data.data.ResMessage);
        this.reDirectGame(gameDetail, GameIndex);
      } else {
        this.reDirectGame(game, index);
      }
    });
  }
  reDirectGame(item, index) {
    this.constant.GameCode = item.GameCode.trim();
    sessionStorage.setItem('GameUrl', JSON.stringify(item.GameUrl));
    sessionStorage.setItem('GameId', JSON.stringify(item.GameID));
    sessionStorage.setItem('GameName', JSON.stringify(item.Name));
    sessionStorage.setItem('GameIndex', index);
    sessionStorage.setItem('AuthToken', this.Token);
    this.constant.gameName = item.Name;
    this.router.navigate(['/games']);
  }
  vacuumLogin(gameCode) {
    if (!this.IsCallMade) {
      this.IsCallMade = true;
      const obj = { gameCode }
      this.gamesService.vacuumLogin(obj).subscribe(data => {
        this.IsCallMade = false;
        if (data.Status.code === this.constant.HttpResponceCode.Success) {
          if (data.RedirectUrl) {
            window.open(data.RedirectUrl, '_blank');
          }
        } else {
          this.toastr.error(this.constant.TranslateErrorCode(data.Status));
          clearInterval(this.balanceInterval);
        }
      }, err => { this.IsCallMade = false; });
    }
  }

  get getLeftScroll() {
    const position = $('#scroll-menu').scrollLeft();
    if (position === 0) {
      return true;
    } else {
      return false;
    }
  }

  left() {
    $('#scroll-menu').stop().animate({ scrollLeft: '-=100' }, 800);
    return false;
  }

  right() {
    $('#scroll-menu').stop().animate({ scrollLeft: '+=100' }, 800);
    return false;
  }
  hideLoader() {
    this.isLoading = false;
  }
  getGameUrl(item, index) {
    const GameCode = 'W' + item.GameCode.trim();
    if (GameCode === 'WTP') {
      item.GameUrl = item.GameUrl.replace('/TP', '/WTP');
    }
    else if (GameCode === 'WDT') {
      item.GameUrl = item.GameUrl.replace('/DT', '/WDT');
    }
    sessionStorage.setItem('widGetGameIndex', index);
    sessionStorage.setItem('widGetGameName', JSON.stringify(item.Name));
    sessionStorage.setItem('widGetGameUrl', item.GameUrl);
    sessionStorage.setItem('AuthToken', this.Token);
    this.router.navigate(['widget',], { queryParams: { Token: this.Token } });
  }

  onImgLoaded(item) {
    this.constant.tmpGameList.forEach(element => {
      if (element.GameID === item.GameID) {
        if (!element.isLoading) {
          element.isLoading = true;
          element.isLoaded = true;
        }
      }
    });
  }
  GameTypePermission(value) {
    if (this.constant.GameTypePermission === 7) {
      // this.gameFilterList(this.fiterType.All);
      return true;
    } else {
      if (value === 'All') {
        return false;
      } else if (value === 'Live') {
        if (this.constant.GameTypePermission === 1 || this.constant.GameTypePermission === 3 || this.constant.GameTypePermission === 5) {
          // this.gameFilterList(this.fiterType.LiveGame);
          return true;
        } else { return false; }
      } else if (value === 'RNG') {
        if (this.constant.GameTypePermission === 2 || this.constant.GameTypePermission === 3 || this.constant.GameTypePermission === 6) {
          // if (this.constant.GameTypePermission === 2 || this.constant.GameTypePermission === 6) {
          //   // this.gameFilterList(this.fiterType.VirtualGame);
          // }
          return true;
        } else { return false; }
      } else if (value === 'Widget') {
        if (this.constant.GameTypePermission === 4 || this.constant.GameTypePermission === 5 || this.constant.GameTypePermission === 6) {
          // if (this.constant.GameTypePermission === 4) {
          //   // this.gameFilterList(this.fiterType.WidGetGame);
          // }
          return true;
        } else { return false; }
      }
    }
  }
  // GameFilter() {
  //   if (this.constant.GameTypePermission === 7) {
  //     this.gameFilterList(this.fiterType.All);
  //   } else {
  //     if (this.constant.GameTypePermission === 1 || this.constant.GameTypePermission === 3 || this.constant.GameTypePermission === 5) {
  //       this.gameFilterList(this.fiterType.LiveGame);
  //     } else if (this.constant.GameTypePermission === 2 || this.constant.GameTypePermission === 6) {
  //       this.gameFilterList(this.fiterType.VirtualGame);
  //     } else if (this.constant.GameTypePermission === 4) {
  //       this.gameFilterList(this.fiterType.WidGetGame);
  //     }
  //   }
  // }
  console(value) {
    console.log(value);
  }
  space(value) {
    return value.replace(/([A-Z])/g, ' $1').trim();
  }
  SeelAll(order) {
    console.log(order);
  }
  fav(game, value) {
    let GameType = game.GameType;
    let favData = {
      GameType: (GameType == 'LiveGame') ? 'Live' : (GameType == 'VirtualGame') ? 'Virtual' : '',
      Gamecode: ""
    };
    let index = -1;
    if (this.constant.OrderViewGame.FavoriteGames) {
      index = this.constant.OrderViewGame.FavoriteGames.findIndex(function (item, i) {
        return item.GameCode.trim() === game.GameCode.trim()
      });
      if (value) {
        if (index >= 0) {
          this.toastr.warning("This game already added in your favorite list");
        } else {
          this.constant.OrderViewGame.FavoriteGames.push(game);
          this.toastr.success("This game added in your favorite list");
        }
      } else {
        if (index >= 0) {
          this.constant.OrderViewGame.FavoriteGames.splice(index, 1);
          this.toastr.success("This game remove from your favorite list");
        } else {
          this.toastr.warning("This game already remove from your favorite list");
        }
      }
      this.constant.OrderViewGame.FavoriteGames.forEach(element => {
        if (GameType === element.GameType) {
          if (favData.Gamecode) {
            favData.Gamecode += "," + element.GameCode;
          } else {
            favData.Gamecode += element.GameCode;
          }
        }
        // favData.push( { GameCode: element.GameCode, GameType: element.GameType } )
      });
    } else {
      if (value) {
        this.constant.OrderViewGame.FavoriteGames = [];
        this.constant.OrderViewGame.FavoriteGames.push(game);
        this.toastr.success("This game added in your favorite list");
      } else {
        this.toastr.warning("This game already remove from your favorite list");
      }
    }

    this.gamesService.Favorite(favData).subscribe((data) => {
      console.log(data);
    });

  }
  CheckFevGame(GameCode) {
    let index = -1;
    if (this.constant.OrderViewGame.FavoriteGames) {
      index = this.constant.OrderViewGame.FavoriteGames.findIndex(function (item, i) {
        return item.GameCode.trim() === GameCode.trim()
      });
      if (index >= 0) { return true; } else { return false; }
    }else{
      return false;
    }
  }
  WinnerName(winner, GameCode) {
    if (GameCode == 'TP' || GameCode == 'TP20' || GameCode == 'VTP' || GameCode == 'VTP20' || GameCode == 'TP7M' || GameCode == 'TPFO' || GameCode == 'MTP7M') {
      return winner == 'Player A' ? 'A' : winner == 'Player B' ? 'B' : 'D';
    } else if (GameCode == 'BAC' || GameCode == 'BAC20' || GameCode == 'VBAC' || GameCode == 'VBAC20') {
      return winner == 'Player' ? 'P' : winner == 'Banker' ? 'B' : 'T';
    } else if (GameCode == 'DT' || GameCode == 'DT7M' || GameCode == 'DT20' || GameCode == 'VDT' || GameCode == 'VDT20') {
      return winner == 'Dragon' ? 'D' : winner == 'Tiger' ? 'T' : 'I';
    } else if (GameCode == 'PK' || GameCode == 'PK20' || GameCode == 'VPK' || GameCode == 'VPK20') {
      return winner == 'Player A' ? 'A' : winner == 'Player B' ? 'B' : 'D';
    } else if (GameCode == 'AB' || GameCode == 'AB20' || GameCode == 'AB2' || GameCode == 'ABC' || GameCode == 'VAB20') {
      return winner == 'Andar' ? 'A' : winner == 'Bahar' ? 'B' : '';
    } else if (GameCode == 'WM' || GameCode == 'VWM') {
      return winner;
    } else if (GameCode == 'ARW' || GameCode == 'VARW') {
      return winner == 'Akbar' ? 'A' : winner == 'Romeo' ? 'R' : 'W';
    } else if (GameCode == 'C32' || GameCode == 'VC32') {
      return winner == 'Player 8' ? '8' : winner == 'Player 9' ? '9' : winner == 'Player 10' ? 10 : 11;
    } else if (GameCode == 'UD7' || GameCode == 'VUD7') {
      return winner == '7Up' ? 'U' : winner == '7Down' ? 'D' : '7';
    } else if (GameCode == 'PK6' || GameCode == 'PK620' || GameCode == 'VPK620' || GameCode == 'VPK6') {
      return winner.replace('Player ', '')[0];
    } else if (GameCode == 'V3CJ' || GameCode == 'D3CJ') {
      return winner.replace(/[{}]/g, "");
    } else if (GameCode == 'V3TP' || GameCode == 'D3TP') {
      return winner == 'Player A' ? 'A' : winner == 'Player B' ? 'B' : winner == 'Player C' ? 'C' : 'D';
    } else if (GameCode == 'VBJ' || GameCode == 'BJ' || GameCode == 'VBJC' || GameCode == 'BJC' || GameCode == 'IBJ') {
      return winner == 'Player' ? 'P' : winner == 'Dealer' ? 'D' : 'T';
    } else if (GameCode == 'VJKR' || GameCode == 'JKR') {
      if (winner === '14') { return 'JK'; }
      else if (winner === '1') { return 'A'; }
      else if (winner === '11') { return 'J'; }
      else if (winner === '12') { return 'Q'; }
      else if (winner === '13') { return 'K'; }
      else { return winner; }
    } else if (GameCode == 'KF' || GameCode == 'VKF') {
      return winner.slice(0, 2);
    } else if (GameCode == 'VCR' || GameCode == 'CR') {
      return winner == 'Spade' ? 'S' : winner == 'Club' ? 'C' : winner == 'Diamond' ? 'D' : 'H';
    } else if (GameCode == 'VRPS' || GameCode == 'RPS') {
      let win = JSON.parse(winner);
      return win.Silver.slice(0, 1) + '-' + win.Gold.slice(0, 1);
    } else if (GameCode == 'SO' || GameCode == 'RSO') {
      return winner == 'TeamA' || winner == 'Team A' ? 'A' : winner == 'TeamB' || winner == 'Team B' ? 'B' : 'T';
    } else if (GameCode == 'CKT20' || GameCode == 'RCKT20') {
      return winner;
    } else if (GameCode == 'CQ' || GameCode == 'RCQ' || GameCode == 'CQ20' || GameCode == 'RCQ20') {
      return winner == 'Player 0' ? '0' : winner == 'Player 1' ? '1' : winner == 'Player 2' ? 2 : 3;
    } else if (GameCode == 'WH' || GameCode == 'RT') {
      return winner == 'Preview' ? 'PR' : winner;
    } else {
      return null;
    }
  }
  setResult(value) {
    if (value > 10) {
      if (Number(value) === 11) { return "J"; }
      else if (Number(value) === 12) { return "Q"; }
      else if (Number(value) === 13) { return "K"; }
      else { return null; }
    } else if (Number(value) === 1) {
      return "A";
    } else {
      return value;
    }
  }
  CheckGameResult(GameCode, index) {
    if (GameCode.trim() == 'D3CJ' || GameCode.trim() == 'V3CJ') {
      if (index <= 2) { return true; } else { return false; }
    } else {
      return true;
    }
  }
}
